import {
  AppConnectionType,
  AppDefinition,
  InstantAvailableStatus,
} from '../../../apps/definition';
import { AppPreferences } from '../../../models/User';

export const showAppInOrgApps = (
  { connectionType, orgModeAvailable, shortname }: AppDefinition,
  appPreferences: AppPreferences
): boolean => {
  if (appPreferences.org_apps_deny_list?.includes(shortname)) {
    return false;
  }

  return (
    orgModeAvailable === true &&
    connectionType !== AppConnectionType.PersonalOnly
  );
};

export const showAppInPersonalApps = (
  { connectionType, shortname }: AppDefinition,
  appPreferences: AppPreferences
): boolean => {
  if (appPreferences.personal_apps_allow_list?.includes(shortname)) {
    return true;
  }

  return (
    connectionType !== AppConnectionType.OrgOnly &&
    connectionType !== AppConnectionType.OrgRestricted &&
    connectionType !== AppConnectionType.Other
  );
};

export const isInstantAvailable = (
  { instantAvailable }: AppDefinition,
  checkForOnly?: InstantAvailableStatus
): boolean => {
  if (instantAvailable === undefined) {
    return false;
  }

  if (checkForOnly === undefined) {
    return instantAvailable !== InstantAvailableStatus.NotAvailable;
  }

  // eslint-disable-next-line no-bitwise
  return (checkForOnly & instantAvailable) === checkForOnly;
};
